import {Pipe, PipeTransform} from '@angular/core';
import {Fulfillment} from '../generated-admin-types';

const SEND = '已发货';
const UNSEND = '未发货';
@Pipe({
  name: 'deliverState',
})
export class DeliverState implements PipeTransform {
  // statesArr = ['Created', 'Draft', 'AddingItems', 'ArrangingPayment', 'PaymentAuthorized', 'PaymentSettled'];
  transform(value: Fulfillment[], orderLineId?: string | number): string {
    console.log(value, orderLineId);
    if (!value?.length) return UNSEND;
    if (value.length && !orderLineId) return SEND;
    return value.find(f => {
      return f.lines.find(l => l.orderLineId === orderLineId);
    })
      ? SEND
      : UNSEND;
  }
}
